// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/financial/invoice.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_money } from "../core/money_pb";
import { file_proto_model_financial_tax_calculation } from "./tax_calculation_pb";

/**
 * Describes the file proto/model/financial/invoice.proto.
 */
export const file_proto_model_financial_invoice = /*@__PURE__*/
  fileDesc("CiNwcm90by9tb2RlbC9maW5hbmNpYWwvaW52b2ljZS5wcm90bxIGY2FybWVuImkKE0ludm9pY2VTdGF0dXNVcGRhdGUSJQoGc3RhdHVzGAEgASgOMhUuY2FybWVuLkludm9pY2VTdGF0dXMSKwoHdXBkYXRlZBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiQQoLRmVlTGluZUl0ZW0SHQoGYW1vdW50GAEgASgLMg0uY2FybWVuLk1vbmV5EhMKC2Rlc2NyaXB0aW9uGAIgASgJIpsBCgVQcmljZRIcCgV0b3RhbBgBIAEoCzINLmNhcm1lbi5Nb25leRIbCgRiYXNlGAIgASgLMg0uY2FybWVuLk1vbmV5EhAKCHF1YW50aXR5GAMgASgCEiEKBGZlZXMYBCADKAsyEy5jYXJtZW4uRmVlTGluZUl0ZW0SIgoFdGF4ZXMYBSADKAsyEy5jYXJtZW4uVGF4TGluZUl0ZW0iTwoLSW52b2ljZUl0ZW0SEwoLZGVzY3JpcHRpb24YASABKAkSHAoFcHJpY2UYAiABKAsyDS5jYXJtZW4uUHJpY2USDQoFbm90ZXMYAyABKAkiBwoFUGF5ZXIiFQoFUGF5ZWUSDAoEbmFtZRgBIAEoCSKtAgoHSW52b2ljZRIKCgJpZBgBIAEoCRIPCgd0cmlwX2lkGAIgASgJEhwKBXBheWVyGAMgASgLMg0uY2FybWVuLlBheWVyEhwKBXBheWVlGAQgASgLMg0uY2FybWVuLlBheWVlEiUKBnN0YXR1cxgFIAEoDjIVLmNhcm1lbi5JbnZvaWNlU3RhdHVzEhwKBXRvdGFsGAYgASgLMg0uY2FybWVuLk1vbmV5EisKB2NyZWF0ZWQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjMKDnN0YXR1c191cGRhdGVzGAggAygLMhsuY2FybWVuLkludm9pY2VTdGF0dXNVcGRhdGUSIgoFaXRlbXMYCSADKAsyEy5jYXJtZW4uSW52b2ljZUl0ZW0qnwEKDUludm9pY2VTdGF0dXMSHgoaSU5WT0lDRV9TVEFUVVNfVU5TUEVDSUZJRUQQABIaChZJTlZPSUNFX1NUQVRVU19QRU5ESU5HEAESFwoTSU5WT0lDRV9TVEFUVVNfUEFJRBACEhwKGElOVk9JQ0VfU1RBVFVTX0NBTkNFTExFRBADEhsKF0lOVk9JQ0VfU1RBVFVTX1JFRlVOREVEEARCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_timestamp, file_proto_model_core_money, file_proto_model_financial_tax_calculation]);

/**
 * Describes the message carmen.InvoiceStatusUpdate.
 * Use `create(InvoiceStatusUpdateSchema)` to create a new message.
 */
export const InvoiceStatusUpdateSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_invoice, 0);

/**
 * Describes the message carmen.FeeLineItem.
 * Use `create(FeeLineItemSchema)` to create a new message.
 */
export const FeeLineItemSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_invoice, 1);

/**
 * Describes the message carmen.Price.
 * Use `create(PriceSchema)` to create a new message.
 */
export const PriceSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_invoice, 2);

/**
 * Describes the message carmen.InvoiceItem.
 * Use `create(InvoiceItemSchema)` to create a new message.
 */
export const InvoiceItemSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_invoice, 3);

/**
 * Describes the message carmen.Payer.
 * Use `create(PayerSchema)` to create a new message.
 */
export const PayerSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_invoice, 4);

/**
 * Describes the message carmen.Payee.
 * Use `create(PayeeSchema)` to create a new message.
 */
export const PayeeSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_invoice, 5);

/**
 * Describes the message carmen.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
export const InvoiceSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_invoice, 6);

/**
 * Describes the enum carmen.InvoiceStatus.
 */
export const InvoiceStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_invoice, 0);

/**
 * Represents the status of an invoice
 *
 * @generated from enum carmen.InvoiceStatus
 */
export const InvoiceStatus = /*@__PURE__*/
  tsEnum(InvoiceStatusSchema);

